import React from 'react';
import styled from '../../styled';
import Text from '../text';
const Container = styled.div `
  display: inline-flex;
  align-items: center;
  line-height: 1.5rem;
  padding: 0 0.5rem;
  border: 1px solid;
  border-color: ${({ theme, color = 'YELLOW_400', borderColor }) => borderColor ? theme.colors[borderColor] : theme.colors[color]};
  background-color: ${({ theme, backgroundColor }) => backgroundColor ? theme.colors[backgroundColor] : 'transparent'};
  border-radius: 13px;
`;
const IconWrapper = styled.div `
  display: flex;
  padding-right: 0.125rem;
`;
const OutlineBadge = ({ lang = 'zh-hant', label, color = 'YELLOW_400', borderColor, backgroundColor, fontType = 'Micro', Icon, renderText, }) => (React.createElement(Container, { color: color, borderColor: borderColor, backgroundColor: backgroundColor },
    Icon && (React.createElement(IconWrapper, null,
        React.createElement(Icon, { size: "XSMALL", color: color }))),
    renderText ? (renderText()) : (React.createElement(Text, { fontType: fontType, lang: lang, color: color }, label))));
export default OutlineBadge;
//# sourceMappingURL=OutlineBadge.js.map